import { StepFieldsMap } from 'sos-common/js/commonTypes';

export const researchOrderStepValidationMap = {
  0: {
    fieldNames: [
      'CurrentResearchOrder.Title',
      'CurrentResearchOrder.HasPriorOrders',
      'CurrentResearchOrder.PdfOnly.AngeVad_PriorOrder',
      'CurrentResearchOrder.ReferenceNumberPriorOrder',
      'CurrentResearchOrder.StudyPopulation.OnlyDeceased',
      'ansokanEtik',
      'forskningsplan',
      'ovrigtilletik',
      'beslutetik',
      'tillagansokanetik',
      'tillagbeslutetik',
      'CurrentResearchOrder.StudyPopulation.HowToCreatePopulation',
      'CurrentResearchOrder.StudyPopulation.DescriptionInApplication.FileId',
      'CurrentResearchOrder.StudyPopulation.DescriptionInApplication.Page',
      'CurrentResearchOrder.StudyPopulation.EstimatedPopulationSize',
      'CurrentResearchOrder.StudyPopulation.CreatedByUs',
      'CurrentResearchOrder.StudyPopulation.CreatedByThem',
      'CurrentResearchOrder.StudyPopulation.CreatedByOtherAuthority',
      'CurrentResearchOrder.StudyPopulation.SavedKeyExist',
      'CurrentResearchOrder.StudyPopulation.SavedKeyLocation',
      'CurrentResearchOrder.StudyPopulation.ShouldSelectPartOfPopulation',
      'CurrentResearchOrder.StudyPopulation.SelectionCriteria',
      'CurrentResearchOrder.DataSources.ProprietaryData',
      'QualityRegistersAreChoosen',
      'CurrentResearchOrder.DataSources.QualityRegisters',
      'ExternalRegistersAreChoosen',
      'CurrentResearchOrder.DataSources.ExternalRegisters',
      'OtherDataSourcesExists',
      'CurrentResearchOrder.DataSources.OtherRegisters',
    ],
    stepId: 0,
  },
  1: {
    fieldNames: [
      'variabellista',
      'CurrentResearchOrder.InternalRegisters',
      'CurrentResearchOrder.RegisterPeriodClarifications[0].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[0].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[0].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[0].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[1].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[1].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[1].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[1].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[2].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[2].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[2].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[2].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[3].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[3].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[3].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[3].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[4].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[4].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[4].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[4].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[5].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[5].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[5].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[5].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[6].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[6].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[6].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[6].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[7].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[7].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[7].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[7].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[8].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[8].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[8].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[8].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[9].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[9].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[9].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[9].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[10].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[10].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[10].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[10].StartDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[11].FileInfo.FileId',
      'CurrentResearchOrder.RegisterPeriodClarifications[11].FileInfo.Page',
      'CurrentResearchOrder.RegisterPeriodClarifications[11].EndDate',
      'CurrentResearchOrder.RegisterPeriodClarifications[11].StartDate',
    ],
    stepId: 1,
  },
  2: {
    fieldNames: [
      'CurrentResearchOrder.DeliveryDefinition.HowToDeliverData',
      'CurrentResearchOrder.FileFormatDeliveredData',
      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId',
      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page',
      'CurrentResearchOrder.DeliveryDefinition.PurposeForSaveSerialNo',
      'CurrentResearchOrder.DeliveryDefinition.MotivationPersonalDataNeeded',
      'CurrentResearchOrder.DeliveryDefinition.IntentToContactCitizens',
      'CurrentResearchOrder.Security.ProtectedByPrivacyLaw',
      'CurrentResearchOrder.Security.PrivacyLaw',
      'CurrentResearchOrder.Security.OsfLaw',
      'CurrentResearchOrder.Security.OtherLaw',
      'CurrentResearchOrder.Security.AllowedDataHandlers',
      'CurrentResearchOrder.Security.AllowedDataHandlers[0].Name',
      'CurrentResearchOrder.Security.AllowedDataHandlers[0].Title',
      'CurrentResearchOrder.Security.AllowedDataHandlers[1].Name',
      'CurrentResearchOrder.Security.AllowedDataHandlers[1].Title',
      'CurrentResearchOrder.Security.AllowedDataHandlers[2].Name',
      'CurrentResearchOrder.Security.AllowedDataHandlers[2].Title',
      'CurrentResearchOrder.Security.AllowedDataHandlers[3].Name',
      'CurrentResearchOrder.Security.AllowedDataHandlers[3].Title',
      'CurrentResearchOrder.Security.AllowedDataHandlers[4].Name',
      'CurrentResearchOrder.Security.AllowedDataHandlers[4].Title',
      'CurrentResearchOrder.Security.PdfOnly.NarArProjektetSlutfort',
    ], // todo.. change matching logic to be fuzzy.. and take simpler fieldNames
    stepId: 2,
  },
  3: {
    fieldNames: [
      'CurrentResearchOrder.ResearchOrganisation',
      'CurrentResearchOrder.ContactPerson.Name',
      'CurrentResearchOrder.ContactPerson.Organisation',
      'CurrentResearchOrder.ContactPerson.Institution',
      'CurrentResearchOrder.ContactPerson.Email',
      'CurrentResearchOrder.ContactPerson.Phone',
      'CurrentResearchOrder.ContactPerson.Address.StreetAddress',
      'CurrentResearchOrder.ContactPerson.Address.ZipCode',
      'CurrentResearchOrder.ContactPerson.Address.City',
      'CurrentResearchOrder.Representative._Representative.Name',
      'CurrentResearchOrder.Representative.WorkTitle',
      'CurrentResearchOrder.Representative._Representative.Institution',
      'CurrentResearchOrder.Representative._Representative.Email',
      'CurrentResearchOrder.BillingDetails.Organisation',
      'CurrentResearchOrder.BillingDetails.OrganisationNumber',
      'CurrentResearchOrder.BillingDetails.BillingReference',
      'CurrentResearchOrder.BillingDetails.BillingAddress.StreetAddress',
      'CurrentResearchOrder.BillingDetails.BillingAddress.ZipCode',
      'CurrentResearchOrder.BillingDetails.BillingAddress.City',
    ],
    stepId: 3,
  },
} as StepFieldsMap;
